import type { WorkflowListing } from "../../../../api/content/workflowsApi";
import type { ThreadEntry } from "../../../../api/threads/liveMessages";
import type { ForkVersions } from "../../hosting/forkVersions";
import { shippedWorkflowOf } from "../shippedWorkflow";

/**
 * Competency questions along the build-out (D-05): a fork at a person's reviewed annotation
 * set onto "Draft competency questions", which binds that set as its evidence
 * (`@fork_point`), so the questions rest on the entries the expert works on.
 */

/** Whether the entry is a person's answer that sent a reviewed annotation set. */
export function holdsReviewedAnnotations(entry: ThreadEntry | undefined): boolean {
  const payload = entry?.payload;
  return payload?.kind === "human_input" && payload.result?.output_kind === "annotations";
}

/** The fork onto the shipped "Draft competency questions" at the newest model version; `null` if the project pins no library that ships it. */
export function forkOntoQuestions(current: ForkVersions, latest: WorkflowListing): ForkVersions | null {
  const questions = shippedWorkflowOf(latest.workflows, "draft_questions");
  return questions === null ? null : { bindings: { ...current.bindings, content_version: latest.version }, workflow: questions.reference };
}
